import { IconButton } from "@mui/material";
import styled from "styled-components";
import { Scroll, Shadow } from "styles/GlobalCss";
import { dark } from "styles/theme";
import { gray, white } from "styles/theme";
import { AnimatePresence, motion } from 'framer-motion';


const PageContent = styled.div`
display: flex;
// justify-content: center;
align-items:center;
height:100%;
width:100%;
justify-content:${props => props.$firstPage ? "start" : "center"};
color:${dark};
`

const WrapPageFlip = styled.div`
display:flex;
column-gap:3px;
width:100%;
align-items:center;

.go-prev-page{
position:absolute;
left:5px;
bottom:5px;
}

.wrap-prev-button {
margin-left: 10px;
}

.book-container {
  // pointer-events:none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.5s ease; /* Smooth transition */
  position: relative;
}

.closed {
  transform: translateX(270px); /* Centered when closed */
}

.open {
  transform: translateX(-270px); /* Move to the left when open */
}
`

const BackAndNextButtons = styled(IconButton)`
width:40px !important;
height:40px !important;

.icon{
font-size:30px !important;
}
`

const WrapCover = styled.div`
background:white;
width:100%;
`

const Circle = styled.div`
height:90%;
width:70%;
background:${white};
border-radius:7000px;
`

const Title = styled.div`
font-weight: bold; 
display: flex;
justify-content: center;
align-items:center;
height:100%;
font-size:45px;
padding:10px;
width:36%;
box-sizing:border-box;
`

const WrapTitle = styled.div`
// transform: scaleX(-1); 
display: flex;
column-gap:10px; 
justify-content: center;
flex-wrap:wrap;
`

const PageText = styled.div`
display: flex;

line-height:  ${props => props.lineHeight ? `${props.lineHeight} !important` : '50px'};
padding: 20px;
font-weight: ${props => props.bold && 'bold'};
font-family:${props => props.fontFamily ? `${props.fontFamily}` : '"Secular One", sans-serif'};
 font-size: ${({ fontsize = 30 }) =>
    `clamp(${fontsize * 0.35}px, 2.5vw, ${fontsize}px)`};

// @media only screen and (max-width: 1400px) {
//   font-size: ${props => props.fontsize * 0.7}px;
// }

// @media only screen and (max-width: 1330px) {
//   font-size: ${props => props.fontsize * 0.67}px;
// }

// @media only screen and (max-width: 1280px) {
//   font-size: ${props => props.fontsize * 0.6}px;
// }


// @media only screen and (max-width: 1100px) {
//   font-size: ${props => props.fontsize * 0.54}px;
// }

// @media only screen and (max-width: 1000px) {
//   font-size: ${props => props.fontsize * 0.47}px;
// }
`

const PageHeader = styled.div`
height: 30px;
display: flex;
justify-content:${props => props.left ? 'start' : 'end'};
`

const WrapPageContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: stretch;

    .page-header {
      height: 30px;
      font-size: 100%;
      text-transform: uppercase;
      text-align: right;
      height: 20px;
      // transform: scaleX(-1);
    }

    .number {
      border: 1px solid #bfbfc5;
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      border-radius: 30px;
      padding: 5px;
      color: #bfbfc5;
      font-weight: bold;
    }

    .page-image {
      height: 100%;
      background-size: contain;
      background-position: center center;
      background-repeat: no-repeat;
    }

    .page-text {
      height: 100%;
      flex-grow: 1;
      text-align: start;
      margin-top: 10px;
      padding-top: 10px;
      box-sizing: border-box;
      justify-content: center;
      line-height:60px;
    }

    .page-footer {
      height: 30px;
      border-top: solid 1px hsl(35, 55, 90);
      font-size: 80%;
      color: hsl(35, 20, 50);
    }

`

const WrapPage = styled.div`
  padding: 20px;
  box-sizing: border-box;
  border-radius: 8px;
  height: 100%;
  
  background-color: hsl(35, 55, 98);
  color: hsl(35, 35, 35);

  overflow-y: auto;
  overflow-x: hidden;
  ${Scroll};
  
`

const WrapPageCover = styled.div`
&.page-cover {
    background-color:#FFD6D4;
    background-image:${props => !props.hideCoverImage && (props.$firstPage ? `url(https://i.ibb.co/xSRRqTpK/Mask-Start.png)` : `url(https://i.ibb.co/5WTVV4xp/End.png)`)};
    background-size: cover;
    padding:0px;
    overflow:hidden;
    color: hsl(35, 35, 35);
    // border:1px solid ${gray};
    // display:flex;
    // justify-content: center;
    // align-items: center; 
    ${Shadow};


    h2 {
      text-align: center;
      padding-top: 50%;
      font-size: 210%;
    }

    &.page-cover-top {
      box-shadow: inset 0px 0 30px 0px rgba(36, 10, 3, 0.5), -2px 0 5px 2px rgba(0, 0, 0, 0.4);
    }

    &.page-cover-bottom {
      box-shadow: inset 0px 0 30px 0px rgba(36, 10, 3, 0.5), 10px 0 8px 0px rgba(0, 0, 0, 0.4);
    }
  }
`

export { BackAndNextButtons, WrapCover, Title, Circle, WrapPageFlip, PageContent, PageText, PageHeader, WrapPage, WrapPageContent, WrapTitle, WrapPageCover }